'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _components = require('../../components');

var _constants = require('../../constants');

var _apple_pay_black = require('../../assets/apple_pay_black.png');

var _apple_pay_black2 = _interopRequireDefault(_apple_pay_black);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PaymentMethodComponent = function PaymentMethodComponent(props) {
  var _props$t = props.t,
      t = _props$t === undefined ? function () {
    var ctx = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return function (msg) {
      return '' + ctx + msg;
    };
  } : _props$t,
      activeCard = props.activeCard,
      isApplePayAvailable = props.isApplePayAvailable;


  var cardLabel = t(_constants.TRANSLATION_CONTEXT)('FORM_LBL_CARD');

  if (isApplePayAvailable) {
    return _react2.default.createElement(
      'div',
      { className: 'form-field card-id' },
      _react2.default.createElement('img', { className: 'label', alt: 'Apple Pay', src: _apple_pay_black2.default }),
      _react2.default.createElement(
        'span',
        { className: 'value' },
        _react2.default.createElement(
          'span',
          { className: 'masked' },
          'Apple Pay'
        )
      )
    );
  }

  return _react2.default.createElement(_components.PaymentMethod, { cardLabel: cardLabel, cardNumber: activeCard.get('summary') });
};

exports.default = PaymentMethodComponent;